export class Webhook {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    name= '',
                    callback= '',
                    type= 0,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.name=name;
        this.callback=callback;
        this.type=type;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;
    }

    get type_name(){
        return Webhook.typeNameByCode(this.type)
    }

    static typeNameByCode(code){
        switch (code){
            case 0:
                return "Envio de Pedido";
        }
        return "";
    }

}

export function createWebhook(data={}) {
    return Object.freeze(new Webhook(data));
}